<template>
    <section id="screen-page">
        <div class="bdr bdr-rad-15 container">
            <h3>Are you a Title Agent looking to close online?</h3>

            <p><a href="/Home/ContactSales">Request a callback from our sales team</a></p>

            <div class="bdr-bottom row">
                <div class="title col-md-12">
                    <div class="col-md-12 text-center">
                        <h2>Contact</h2>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-md-offset-3 text-left profile">
                <div class="row">
                    <contact-form />
                </div>
            </div>
        </div>
      <p>xxx yyy</p>
    </section>


</template>

<script>
    import ContactForm from "@/components/forms/ContactForm.vue";
    export default {
        name: 'Contact',
        components: { ContactForm  },
      data() {
          return {
            TITLE: process.env.TITLE,
            APP_TITLE: process.env.APP_TITLE,
            VUE_APP_TITLE: process.env.VUE_APP_TITLE,
            NODE_ENV: process.env.NODE_ENV,
            VUE_APP_GLANCEURL: process.env.VUE_APP_GLANCEURL,
          }
      },
      mounted() {
        const plugin = document.createElement("script");
        plugin.id = "glance-cobrowse";
        plugin.type = "text/javascript";
        plugin.dataset.groupid = "20408";
        plugin.dataset.site = "staging";
        plugin.charset = "UTF-8";
        plugin.setAttribute(
            "src",
            process.env.VUE_APP_GLANCEURL,
        );
        plugin.async = true;
        document.head.appendChild(plugin);

      }
    }
</script>

